import React from 'react';
const TabMemuClose = (props) => {
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    const strokeColor = props.stroke || '#7D8085';
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M4 4L8 8M8 8L4 12M8 8L12 4M8 8L12 12", stroke: strokeColor, strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default TabMemuClose;
